export const GET_TOPICS = 'GET_TOPICS';

export const ACCESS_TOKEN = 'ACCESS_TOKEN';
export const CHANGE_ACCESS_TOKEN = 'CHANGE_ACCESS_TOKEN';
export const GET_MESSAGE_COUNT = 'GET_MESSAGE_COUNT';
export const GET_INFO = 'GET_INFO';
export const AUTH_OR_NOT = 'AUTH_OR_NOT';
export const GET_MESSAGE = 'GET_MESSAGE';

export const GET_TOPIC = 'GET_TOPIC';

export const GET_USER = 'GET_USER';
export const GET_COLLECT = 'GET_COLLECT';
// export const GET_RECENT = 'GET_RECENT';
